import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { useDocumentTitle } from '@/router/use-document-title';
import { useDataLayerPageview } from '@/router/use-datalayer-pageview';
import { IdentityConfirmationHost } from '@/features/account/identity-confirmation';

export interface RouterContext {
  query: QueryClient;
}

function DocumentTitle() {
  useDocumentTitle();
  // EU-392 / DLR-001 — `virtual_pageview` a cada navegação. Roda APÓS o
  // `useDocumentTitle` (mesmo componente) para ler o `document.title` já atual.
  useDataLayerPageview();
  return null;
}

function RootComponent() {
  return (
    <>
      <DocumentTitle />
      <Outlet />
      {/* DEV-555 — "Confirme sua identidade" (um modal para o app inteiro) + retorno do provedor. */}
      <IdentityConfirmationHost />
    </>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
